import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { licenseIdParam, orgIdParam, userIdParam } from './builderHelper';

export const licenseResources = {
  /** @todo i think permissions need to be added */
  getLicenseDetails: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/:license_id',
    EResourceMethod.Get,
    orgIdParam(userIdParam(licenseIdParam()))
  ),
  getUserLicenses: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license',
    EResourceMethod.Get,
    orgIdParam(userIdParam())
  ),
  assignLicense: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license',
    EResourceMethod.Post,
    orgIdParam(userIdParam())
  ),
  unassignLicense: createResourceBuilder(
    /** @todo check permissions */
    '/licensing/org/:organization_id/user/:user_id/license/:license_id',
    EResourceMethod.Delete,
    orgIdParam(userIdParam(licenseIdParam()))
  ),
  generateAirgap: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/offline',
    EResourceMethod.Post,
    orgIdParam(userIdParam())
  ),
  generateAirgapLegacy: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/:license_id/offline',
    EResourceMethod.Post,
    orgIdParam(userIdParam()) /** license_id is passed during execution */
  ),
  getPixotopeVersion: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/get-offlic-req-version',
    EResourceMethod.Post,
    orgIdParam(userIdParam())
  ),
  forceRelease: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/:license_id/forced',
    EResourceMethod.Delete,
    orgIdParam(userIdParam(licenseIdParam()))
  ),
  releaseOnline: createResourceBuilder(
    /** @todo update permissions */
    '/licensing/org/:organization_id/user/:user_id/license/:license_id/online',
    EResourceMethod.Delete,
    orgIdParam(userIdParam(licenseIdParam()))
  ),
  releaseAirgap: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/offline/release',
    EResourceMethod.Post,
    orgIdParam(userIdParam())
  ),
  releaseAirgapLegacy: createResourceBuilder(
    '/licensing/org/:organization_id/user/:user_id/license/:license_id/offline/release',
    EResourceMethod.Post,
    orgIdParam(userIdParam()) /** license_id is passed during execution */
  ),
  unassignedLicenses: createResourceBuilder(
    '/licensing/org/:organization_id/license/unassigned',
    EResourceMethod.Get,
    orgIdParam()
  ),
  getOrganizationLicenses: createResourceBuilder(
    '/licensing/org/:organization_id/licenses',
    EResourceMethod.Get,
    orgIdParam()
  ),
};
